import { STATE_SERVICE } from '../../configs/constants';

export const excludedConsoleMethods = ['log', 'info', 'error', 'warn', 'setLevel'];

export interface IUANCState {
    isDebugMode: boolean;
    isAdoScriptReady: boolean;
    ADOCEANServiceState: STATE_SERVICE;
    isGoogleScriptReady: boolean;
    DFPServiceState: STATE_SERVICE;
    isPrebidReady: boolean;
    TesterServiceState: STATE_SERVICE;
    runUANC: boolean;
    isReloadUanc: boolean;
    isAdBlockDetect: boolean;
    reloadAdConsole: boolean;
}

export const getInitialUANCState = (isDebugVersion: boolean = false): IUANCState => {
    return {
        isDebugMode: isDebugVersion,
        isAdoScriptReady: false,
        ADOCEANServiceState: STATE_SERVICE.PENDING,
        isGoogleScriptReady: false,
        DFPServiceState: STATE_SERVICE.PENDING,
        isPrebidReady: false,
        TesterServiceState: STATE_SERVICE.PENDING,
        runUANC: true,
        isReloadUanc: false,
        isAdBlockDetect: false,
        reloadAdConsole: false,
    };
};
